let language = {
  en: {
    'Settings_Panel_Info': 'Setting Panel',
    'Points_Rule': 'Points Rule',
    'Create_Account': 'Create Account',
    'Reset_Password': 'Reset Password',
    'Instapap_Secure_Login': 'Instapap Secure Login',
    'Welcome_back_login': 'Welcome Back',
    'Login': 'Login',
    'Email_Address': 'Email Address',
    'Password': 'Password',
    'Complete': 'Complete',
    'Months_Before_Well_Check_Due': '3 Months Before Well-Check Due',
    'Day_Well_Check_Is_Due': 'Day Well Check Is Due',
    'Month_Before_Well_Check_Due': '1 Month Before Well-Check Due',
    'One_Week_After_Well_Check_Due': 'One Week After Well Check Due',
    'Monthly_After_Final_Email': 'Monthly After Final Email',
    'Account_Info': 'Account Info',
    'Personal_Info': 'Personal Info',
    'Email_Preferences': '3. Email Preferences',
    'Street_and_number': 'Street and number, P.O. Box, c/o',
    'Clinic_Info': 'Clinic Info',
    'Clinic_Name': 'Clinic Name',
    'Apartment_suite_unit_building': 'Apartment, suite, unit, building, floor, etc.',
    'Country': 'Country',
    'City': 'City',
    'State': 'State',
    'Postal_Code': 'Postal Code',
    'Phone': 'Phone',
    'Continue': 'Continue',
    'Device_MAC': 'Device MAC',
    'Calendly_API_Key': 'Calend.ly API Key',
    'Tax_ID': 'Tax ID',
    'Practitioner_ID': 'Practitioner ID',
    'Email': 'Email',
    'Name': 'Name',
    'Confirm_Password': 'Confirm Password',
    'Preferences': 'Preferences',
    'Privacy_Policy': 'Privacy Policy',
    'Terms_Conditions': 'Terms & Conditions',
    'About_Us': 'About Us',
    'Referred_by:': 'Referred by:',
    'View': 'View',
    'Choose_Test_Date': 'Choose Test Date',
    'View_Past_Test': 'View Past Test',
    'Initiate_InstaPap_Test': 'Initiate InstaPap Test',
    'Last_Appt': 'Last Appt :',
    'Address': 'Address',
    'Birthday': 'Birthday ',
    'Cell_Phone': 'Cell Phone',
    'Settings': 'Settings',
    'Update_Status': 'Update Status',
    'Match_Tests': 'Match Tests',
    'DOB': 'DOB',
    'Profile': 'Profile',
    'History': 'History',
    'Status_Notes': 'Status/Notes',
    'Dismiss': 'DISMISS',
    'Continue_Match': 'Continue',
    'Update_Now': 'Update Now',
    'InstaPap_Match': '{xx} InstaPap test results need to be matched with patients. Please resolve as soon as possible.',
    'Critical_Alert': 'Critical Alert',
    'Account_Info': 'Account Info',
    'Results': 'Results',
    'Notes': 'Notes',
    'Physical_Examination_Notes': 'Physical Examination Notes',
    'Test_Notes': 'Test Notes',
    'Current_Conditions_Notes': 'Current Conditions Notes',
    'Expected_Results_Date': 'Expected Results Date',
    'Next_Step': 'Next Step',
    'Complete_Next_Steps': 'Complete Next Steps',
    'generate_a_report': 'Input next step to generate a report.',
    'Appointment_Time': 'Appointment Time',
    'Appt_Date': 'Appt Date',
    'Schedule_Next_Appt': '2. Schedule Next Appt',
    'Schedule_follow_up_visit': 'Schedule a follow-up visit.',
    'Print': 'Print',
    'Share_Report': 'Share Report',
    'Complete_all_steps_share': 'Complete all steps to share.',
    'Show_Graphs': 'Show Graphs',
    'InstaPap_Results': 'InstaPap Results',
    'Report_Notes': 'Report Notes',
    'Review_Now': 'Review Now',
    'entered_any_next_steps': 'You have not entered any next steps. Please review examination questions.',
    'Warning': 'Warning',
    'Interview': 'Interview',
    'Predispositions': 'Predispositions',
    'Observations': 'Observations',
    'Patient_Profile': 'Patient Profile',
    'New_Test_Date_Time': 'New Test Date Time',
    'Next_Appt': 'Next Appt :',
    'Edit_Profile': 'Edit Profile',
    'Delete_Profile': 'Delete Profile',
    'Back': 'Back',
    'Save_Changes': 'Save Changes',
    'Birthday': 'Birthday ',
    'Next_Appt': 'Next Appt :',
    'Last_Appt': 'Last Appt :',
    'Colposcopy': 'Colposcopy',
    'Instapap': 'InstaPap',
    'PapSmear': 'PapSmear',
    'Biopsy': 'Biopsy',
    'CIN_1': 'CIN 1',
    'CIN_2': 'CIN 2',
    'LSIL': 'LSIL',
    'HSIL': 'HSIL',
    'CIN_3': 'CIN 3',
    'Cytology': 'Cytology',
    'Histology': 'Histology',
    'File': 'File',
    'Today': 'Today',
    'Very_mild_mild': 'Very mild/ mild dysplasia',
    'Moderate_dysplasia': 'Moderate dysplasia',
    'Severe_dysplasia': 'Severe dysplasia',
    'In_situ_carcinoma': 'In situ carcinoma',
    'Invasive_carcinoma': 'Invasive carcinoma',
    'Normal': 'Normal',
    'Test': 'Test',
    'Papsmear': 'Papsmear',
    'Physical_Examination': 'Physical Examination',
    'Current_Conditions': 'Current Conditions',
    'Papsmear_Moderate_Dysplasia': 'Papsmear _ - Moderate Dysplasia',
    'Edit_Results': 'Edit Results',
    'Patient_History': 'Patient History',
    'Add_Test': 'Add Test',
    'Add_Files': 'Add Files',
    'Test_Type': 'Test Type',
    'Test_Date': 'Test Date',
    'Status': 'Status',
    'Result_Date': 'Result Date',
    'Last_Pap_Smear': 'Years Since Last Pap Smear',
    'Last_Menstruation': 'Last Menstruation',
    'smoke': 'Do you smoke?',
    'Cesareans': 'Cesareans',
    'Pregnancies': 'pregnancies',
    'sexual_partners': 'sexual partners',
    'sexual_partner': 'sexual partner',
    'cigarettes_per_day': 'cigarettes per day',
    'Abortions': 'Abortions',
    'Live_Births': 'Live Births',
    'Sexual_Activity_Initiated': 'When Sexual Activity Initiated',
    'Age_When_Sexual_Activity_Initiated': 'Age When Sexual Activity Initiated',
    'Anal_Sex': 'Anal Sex',
    'Ethnicity': 'Ethnicity',
    'test_notes_here': 'Enter test notes here…',
    'Save': 'Save',
    'Due:': 'Due:',
    'Past_Due': 'Past Due',
    'In_Progress': 'In Progress',
    'Welcome_back': 'Welcome back',
    'Today_Appointments': 'Today’s Appointments',
    'Birthdate': 'Birthdate',
    'Age': 'Age',
    'Last_Visit': 'Last Visit',
    'Next_Visit': 'Next Visit',
    'Last_Name_First_Name': 'Last Name, First Name',
    'Add': 'Add',
    'Patient_Database': 'Patient Database',
    'Search_Patients': 'Search Patients',
    'Reason_Appointment': 'Reason for the Appointment',
    'Personal_Predispositions': 'Personal Predispositions',
    'Hereditary_Predispositions': 'Hereditary Predispositions',
    'Patological_Predispositions': 'Patological Predispositions',
    'Edit_History': 'Edit History',
    'Years': 'Years',
    'Last_Pap_Smear': 'Last Pap Smear',
    'Pregnancies': 'Pregnancies',
    'Yes': 'Yes',
    'Anal_Sex': 'Anal Sex',
    'Cigarettes_Day': 'Cigarettes/Day',
    'First_Sexual_Activity': 'First Sexual Activity',
    'Smoker': 'Smoker',
    'Sexual_Partners': 'Sexual Partners',
    'Weight': 'Weight',
    'Hispanic': 'Hispanic',
    'Ethnicity': 'Ethnicity',
    'Height': 'Height',
    'Last_Menstruation': 'Last Menstruation',
    'Drag_boxes_change_results': 'Drag boxes between columns to change the results',
    'Delete': 'Delete?',
    'Match_Now': 'Match Now',
    'Profile': 'Profile',
    'History': 'History',
    'New_InstaPap': 'New InstaPap',
    'Height_meters': 'Height in meters',
    'Weight_kg': 'Weight in kg',
    'kg': 'kg',
    'Do_you_smoke': 'Do you smoke?',
    'Number_Cesareans': 'Number of Cesareans',
    'Number_Pregnancies': 'Number of Pregnancies',
    'Number_Sexual_Partners': 'Number of Sexual Partners',
    'cigarettes_day': 'How many cigarettes per day?',
    'Number_Abortions': 'Number of Abortions',
    'Number_Live_Births': 'Number of Live Births',
    'Anal_Sex': 'Anal Sex?',
    'Save_test_later': 'Save and test later',
    'Add_Patient': 'Add Patient',
    'Last_Name': 'Last Name (Apellidos)',
    'First_Name': 'First Name',
    'How_hear_about_us': 'How did you hear about us?',
    'Cancel': 'Cancel',
    'Choose': 'Choose',
    'Other': 'Other',
    'Irregular_vaginal': 'Irregular vaginal/cervical bleeding',
    'Symptoms_Present:': 'Symptoms Present:',
    'Observed_Conditions:': 'Observed Conditions:',
    'Postcoital_bleeding': 'Postcoital bleeding',
    'Vaginal_discharge': 'Vaginal discharge',
    'Smooth': 'Smooth',
    'Nabothian_Cyst': 'Nabothian Cyst',
    'Hypertrophy': 'Hypertrophy',
    'Leucoplasia': 'Leucoplasia',
    'Inflammation': 'Inflammation',
    'Laceration': 'Laceration',
    'Polyp': 'Polyp',
    'Suspicious_Lesion': 'Suspicious Lesion',
    'Finish': 'Finish',
    'Continue_Anyway': 'Continue Anyway',
    'Abandon_Test': 'Abandon Test',
    'Pre_Interview_1': 'InstaPap should not be used for women with symptoms, e.g. abnormal vagina or postcoital bleeding, and it should not be used for women with an abnormal looking cervix.  These women need colposcopy, biopsy, hysteroscopy, uterine curettage etc, depending on the clinical history and findings upon examination.',
    'Confirm_Initiate_Test': 'Confirm and Initiate InstaPap Test',
    'Pre_Interview_2': 'Is the patient pregnant?',
    'Pre_Interview_3': 'Has the patient received a Pap smear within the last 6 weeks?',
    'Pre_Interview_4': 'Is the patient less than 4 months post-partum?',
    'Pre_Interview_5': 'Is the patient currently in days 1-3 of her menstrual period with heavy flow?',
    'Pre_Interview_6': 'Has the patient received surgical treatment to the cervix in the last 3 months (including punch biopsies)?',
    'Pre_Interview_7': 'Has the patient received radiotherapy treatment in the pelvic region at any time previously?',
    'Pre_Interview_8': 'Is the patient receiving or has received chemotherapy in the last 5 weeks?',
    'Pre_Interview_9': 'Has the patient previously undergone a hysterectomy (corpus or cervix)?',
    'Pre_Interview_10': 'Does the patient have a clinically apparent acute or subacute infection of the cervix of vagina?',
    'Pre_Interview_11': 'Does the patient have a photosensitising disease, is receiving photodynamic therapy or is otherwise exposed to photosensitising drugs?',
    'Exclusion_Criteria': 'Exclusion Criteria',
    'Try_Again': 'Try Again',
    'Dock_Device_Save': 'Dock Device to Save Data and Complete Test',
    'Time': 'Time',
    'Patient': 'Patient',
    'Points': 'Points',
    'Result': 'Result',
    'Edit': 'Edit',
    'Abnormal': 'Abnormal',
    'still_need_matched': '${xx} test(s) was/were updated. ${yy} tests still need to be matched.',
    'Saved': 'Saved',
    'Edit_Profile_Image': 'Edit Profile Image',
    'Device_MAC': 'Device MAC',
    'Calendly_Key': 'Calend.ly API Key',
    'Tax_ID': 'Tax ID',
    'Practitioner_ID': 'Practitioner ID',
    'Personal_Info': 'Personal Info',
    'Email_Preferences': 'Email Preferences',
    'Add_Device_MAC': 'Add Device MAC',
    'Results_Date': 'Results Date',
    'Upload_File': 'Upload File',
    'Type': 'Type',
    'Results': 'Results',
    'Status_Update': 'Status Update',
    'edit_notes': 'edit notes',
    'status_record_updated_reviewed': '{xx} patient status record(s) was/were updated. {xx} records still need to be reviewed.',
    'location_of_lesion': 'Please click the location of the lesion',
    'InstaPap_Test_Interview': 'InstaPap Test Interview',
    'InstaPap_Test': 'InstaPap Test',
    'Processing_Test': 'Processing Test',
    'View_Results': 'View Results',
    'Return_Test': 'Return to Test',
    'abandon_test_message': 'Are you sure you want to abandon test? All test data will be deleted. This action can not be undone.',
    'Years': 'Years',
    'Years_Old': 'Years Old',
    'years_old': 'years old',
    'Please_complete_interview': 'Please complete interview then you may view results.',
    'Please_perform_test': 'Please perform test then dock device.Waiting for device to be docked to process results.',
    'Accept': 'Accept',
    'TruScreen': 'TruScreen',
    'PapSmear_Liquid': 'PapSmear Liquid-based',
    'HPV_DNA': 'HPV DNA',
    'Maual_InstaPap': 'Maual InstaPap',
    'Observation': 'Observation',
    'Annual_Checkup': 'Annual Checkup',
    'Enter_note_here': 'Enter note here...',
    'These_are_report_notes': 'These are my report notes',
    'No': 'No',
    'cigarettes': 'cigarettes',
    'pregnancy': 'pregnancy',
    'pregnancies': 'pregnancies',
    'live_births': 'live births',
    'live_birth': 'live birth',
    'cesareans': 'cesareans',
    'cesarean': 'cesarean',
    'abortions': 'abortions',
    'abortion': 'abortion',
    'hispanic': 'hispanic',
    'other': 'other',
    'None': 'None',
    'Low': 'Low',
    'Med': 'Med',
    'High': 'High',
    'Physical_examination_notes': 'Enter physical examination notes...',
    'Current_conditions_notes': 'Enter current conditions notes...',
    'Forgot_password': 'Forgot your password?',
    'Enter_email_reset_password': 'Enter your email address and you’ll receive a link to reset your password.',
    'Back_to_Login': 'Back to Login',
    'Email_not_exist': 'Email account does not exist',
    'We_sent_an_email': 'We just sent an email to ${xx}. Click the link we sent to reset your password. If you didn’t receive an email, check your spam folder.',
    'Fill_Clinic_Info': 'Please fill out Clinic Info',
    'Device_MAC_required': 'Device MAC is required',
    'New_Patient_Name': '+ New Patient Name',
    'Logout': 'Logout',
    'Enter_new_Password': 'Enter a new Password',
    'New_Password': 'New Password',
    'Confirm_New_Password': 'Confirm New Password',
    'Your_password_changed': 'Your password has been changed.',
    'Save_Dismiss': 'Save and Dismiss',
    'Email_not_valid': 'Email is not valid!',
    'Email_password_incorrect': 'The email or password is incorrect!',
    'Please_close_window': 'Please restart test and close window',
    'Added_patient_successfully': 'Added patient successfully',
    'Created_exam_successfully': 'Created exam successfully',
    'Passwords_not_Match': 'Passwords do not Match',
    'Password_reset_failed': 'Password reset failed',
    'Token_expired': 'Token expired',
    'Update_complete': 'Update complete',
    'Error_signing_up': 'Error signing up, please try again later',
    'MAC_already_use': 'That MAC is already in use',
    'Password_confirmation_failed': 'Password confirmation failed!',
    'Email_password_required': 'The Email and password is required!',
    'White': 'White',
    'Indigenous': 'Indigenous',
    'Mestizo': 'Mestizo',
    'Asian': 'Asian',
    'African': 'African',
    'Arab': 'Arab',
    'Other': 'Other',
    'Add_New_Test_Result': 'Add New Test Result',
    'Manual_InstaPap': 'Manual InstaPAP',
    'No_Status_Available': 'No Status Available',
    'No_Patients_Available': 'No Patients Available',
    'No_Tests_Available': 'No Tests Available',
    'Upcoming_appointments': 'Upcoming Appointments',
    'No_Upcoming_appointments': 'No Upcoming Appointments',
    'Add_New_Patient': 'Add New Patient',
    'Doctor_Database': 'Doctor Database',
    'Search_Doctors': 'Search Doctors',
    'Location': 'Location',
    'Patients': 'Patients',
    'No_Doctors_Available': 'No Doctors Available',
    'Add_New_Doctor': 'Add New Doctor',
    'Super_Admin': 'Super Admin',
    'Exit_Admin': 'Exit Admin',
    'Add_Doctor': 'Add Doctor',
    'Doctor_Profile': 'Doctor Profile',
    'Dr': 'Dr',
    'Clinic': 'Clinic',
    'Calendly': 'Calendly',
    'google_calendar': 'Google Calendar Link (Secret address in iCal format)',
    'google_calendar_admin': 'Google Calendar Link',
    'google_calendar_how': 'How do I find my google calendar link?',
    'Account_info': 'Account Info',
    'Personal_info': 'Personal Info',
    'Clinic_info': 'Clinic Info',
      'update_review_plural': 'patient status records were updated.',
      'update_review': 'patient status record was updated.',
      'no_update_review': 'No patient status records were updated.',
      'need_review_plural': 'records still need to be reviewed.',
      'need_review': 'records still need to be reviewed.',
      'no_need_review': 'No record need to be reviewed.',
      'Phone_Unvalid': 'Phone number is not valid.',
      'messages_on_patient_history_has_no_test': 'This patient has no current test results. Input one now or initiate a new InstaPAP test.',
      'how_to_find_gg_calendar_url': 'How do I find my google calendar URL?',
      'gg_calendar_url': 'https://support.google.com/calendar/answer/37648?hl=en.&vid=0-1244701042136-1527043408766',
      'footer_link': 'http://onko.us',
      'no_test': 'No test',
      'delete_patient_start': 'You are permanently deleting patient record:',
      'delete_patient_end': 'This cannot be undone.',
      'delete_patient_record': 'Confirm',
      'are_you_sure_delete_test': 'Are you sure to delete this test?',
      'Edit_Email': 'Edit Email',
      'To': 'To',
      'Subject': 'Subject',
      'Email_body': 'Email body',
      'Email_content...': 'Email content...',
      'Send': 'Send',
      'Email_Sent': 'Email Sent!',
      'Dismiss_Email': 'Continue',
  },
  'sp': {
    'Settings_Panel_Info': 'Panel de Configuración',
    'Points_Rule': 'Regla de puntos',
    'Create_Account': 'Crea una cuenta',
    'Reset_Password': 'Restablecer contraseña',
    'Instapap_Secure_Login': 'Inicio de sesión InstaPAP',
    'Welcome_back_login': '¡Bienvenido!',
    'Login': 'Ingresar',
    'Email_Address': 'Correo electrónico',
    'Password': 'Contraseña',
    'Complete': 'Completo',
    'Months_Before_Well_Check_Due': 'Enviar email a la paciente 3 meses antes de la prueba',
    'Day_Well_Check_Is_Due': 'Enviar email a la paciente el día de la prueba',
    'Month_Before_Well_Check_Due': 'Enviar email a la paciente 1 mes antes de la prueba',
    'One_Week_After_Well_Check_Due': 'Enviar email a la paciente 1 semana después de que tuvo que haberse hecho la prueba',
    'Monthly_After_Final_Email': 'Enviar mail a la paciente mensualmente',
    'Account_Info': 'Información de la cuenta',
    'Personal_Info': 'Información personal',
    'Email_Preferences': 'Preferencias de correo electrónico',
    'Street_and_number': 'Calle y número',
    'Clinic_Info': 'Información de la clínica',
    'Clinic_Name': 'Nombre de la clínica',
    'Apartment_suite_unit_building': 'Edificio, piso, consultorio, etc.',
    'Country': 'País',
    'City': 'Ciudad',
    'State': 'Estado',
    'Postal_Code': 'Código postal',
    'Phone': 'Teléfono',
    'Continue': 'Continuar',
    'Device_MAC': 'MAC del dispositivo',
    'Calendly_API_Key': 'Llave de API Calend.ly',
    'Tax_ID': 'Identificación de impuestos',
    'Practitioner_ID': 'Identificación del médico',
    'Email': 'Correo electrónico',
    'Name': 'Nombre',
    'Confirm_Password': 'Confirmar Contraseña',
    'Preferences': '3. Preferencias',
    'Privacy_Policy': 'Política de Privacidad',
    'Terms_Conditions': 'Términos y Condiciones',
    'About_Us': 'Acerca de Nosotros',
    'Referred_by:': 'Recomendada por',
    'View': 'Ver',
    'Choose_Test_Date': 'Elige la fecha de la prueba',
    'View_Past_Test': 'Ver pruebas pasadas',
    'Initiate_InstaPap_Test': 'Iniciar la prueba InstaPAP',
    'Last_Appt': 'Última cita :',
    'Address': 'Dirección',
    'Birthday': 'Fecha de nacimiento ',
    'Cell_Phone': 'Teléfono celular',
    'Settings': 'Configuraciones',
    'Update_Status': 'Actualizar estado',
    'Match_Tests': 'Emparejar resultados',
    'DOB': 'Fecha de nacimiento',
    'Profile': 'Perfil',
    'History': 'Historial',
    'Status_Notes': 'Estados/Notas',
    'Dismiss': 'Descartar', //"Descartar"
    'Continue_Match': 'Continuar',
    'Update_Now': 'Actualizar ahora',
    'InstaPap_Match': '{xx} Se necesita emparejar los resultados de la prueba InstaPAP con las pacientes. Favor de resolver lo más pronto posible.',
    'Critical_Alert': 'Alerta crítica',
    'Account_Info': 'Información de la cuenta',
    'Results': 'Resultado',
    'Notes': 'Notas',
    'Physical_Examination_Notes': 'Notas de la examinación física',
    'Test_Notes': 'Notas de la prueba',
    'Current_Conditions_Notes': 'Notas de las condiciones actuales',
    'Expected_Results_Date': 'Fecha esperada de los resultados',
    'Next_Step': 'Siguiente paso',
    'Complete_Next_Steps': '1. Complete los siguientes pasos',
    'generate_a_report': 'Realice el siguiente paso para generar reporte.',
    'Appointment_Time': 'Hora de la cita',
    'Appt_Date': 'Fecha de la cita',
    'Schedule_Next_Appt': 'Agendar la siguiente cita',
    'Schedule_follow_up_visit': 'Agendar una cita de seguimiento.',
    'Print': 'Imprimir',
    'Share_Report': 'Compartir reporte',
    'Complete_all_steps_share': 'Complete todos los pasos para compartir.',
    'Show_Graphs': 'Mostrar gráficas',
    'InstaPap_Results': 'Resultados InstaPAP',
    'Report_Notes': 'Notas del Reporte',
    'Review_Now': 'Revisar ahora',
    'entered_any_next_steps': 'No ha especificado ningún paso. Por favor revise las preguntas de la prueba.',
    'Warning': 'Advertencia',
    'Interview': 'Entrevista',
    'Predispositions': 'Predisposiciones',
    'Observations': 'Observaciones',
    'Patient_Profile': 'Perfil de la paciente',
    'New_Test_Date_Time': 'Fecha y hora de la nueva prueba',
    'Next_Appt': 'Siguiente cita :',
    'Edit_Profile': 'Editar perfil',
    'Delete_Profile': 'Borar perfil',
    'Back': 'Atrás',
    'Save_Changes': 'Guardar cambios',
    'Birthday': 'Cumpleaños ',
    'Next_Appt': 'Siguiente cita :',
    'Last_Appt': 'Última cita :',
    'Colposcopy': 'Colposcopía',
    'Instapap': 'InstaPAP',
    'PapSmear': 'Papanicolaou',
    'Biopsy': 'Biopsia',
    'CIN_1': 'NIC 1',
    'CIN_2': 'NIC 2',
    'LSIL': 'LIE Bajo grado',
    'HSIL': 'LIE Alto grado',
    'CIN_3': 'NIC 3',
    'Cytology': 'Citología',
    'Histology': 'Histología',
    'File': 'Archivo',
    'Today': 'Hoy',
    'Very_mild_mild': 'Displasia leve',
    'Moderate_dysplasia': 'Displasia moderada',
    'Severe_dysplasia': 'Displasia severa',
    'In_situ_carcinoma': 'Carcinoma in situ',
    'Invasive_carcinoma': 'Carcinoma invasivo',
    'Normal': 'Normal',
    'Test': 'Prueba',
    'Papsmear': 'Papanicolaou',
    'Physical_Examination': 'Examinación física',
    'Current_Conditions': 'Condiciones actuales: Haga click para añadir notas',
    'Papsmear_Moderate_Dysplasia': 'Papanicolaou - Displasia moderada',
    'Edit_Results': 'Editar resultados',
    'Patient_History': 'Historial de la paciente',
    'Add_Test': 'Añadir prueba',
    'Add_Files': 'Añadir archivo',
    'Test_Type': 'Tipo de la prueba',
    'Test_Date': 'Fecha de la prueba',
    'Status': 'Estado',
    'Result_Date': 'Resultado de la prueba',
    'Last_Pap_Smear': 'Años desde el último Papanicolaou',
    'Last_Menstruation': 'Último periodo menstrual',
    'smoke': '¿Fumas?',
    'Pregnancies': 'Embarazos',
    'Sexual_Partners': 'Compañeros sexuales',
    'sexual_partners': 'compañeros sexuales',
    'sexual_partner': 'compañeros sexuales',
    'cigarettes_per_day': 'cigarrillos al día',
    'abortions': 'abortos',
    'abortion': 'aborto',
    'Live_Births': 'nacimientos vivos',
    'Sexual_Activity_Initiated': 'Edad en que comenzó actividad sexual',
    'Age_When_Sexual_Activity_Initiated': 'Edad en que comenzó actividad sexual',
    'Anal_Sex': 'Sexo anal',
    'Ethnicity': 'Origen étnico',
    'test_notes_here': 'Añada notas de la prueba aquí:',
    'Save': 'Guardar cambios',
    'Due:': 'Límite',
    'Past_Due': 'Después del límite',
    'In_Progress': 'En progreso',
    'Welcome_back': 'Bienvenido',
    'Today_Appointments': 'Citas del día de hoy',
    'Birthdate': 'Fecha de nacimiento',
    'Age': 'Edad',
    'Last_Visit': 'Última visita',
    'Next_Visit': 'Siguiente visita',
    'Last_Name_First_Name': 'Apellido, nombre',
    'Add': 'Añadir',
    'Patient_Database': 'Base de datos de pacientes',
    'Search_Patients': 'Buscar paciente',
    'Reason_Appointment': 'Razón de la cita',
    'Personal_Predispositions': 'Predisposiciones personales',
    'Hereditary_Predispositions': 'Predisposiciones hereditarias',
    'Patological_Predispositions': 'Predisposiciones histológicas',
    'Edit_History': 'Editar historial',
    'Live_Births': 'Nacimientos vivos',
    'Years': 'años',
    'years_old': 'años',
    'Last_Pap_Smear': 'Último Papanicolaou',
    'Pregnancies': 'Embarazos',
    'Yes': 'Si',
    'Anal_Sex': 'Sexo anal',
    'Cigarettes_Day': 'Cigarrillos al día',
    'First_Sexual_Activity': 'Primera actividad sexual',
    'Smoker': 'Fumadora',
    'Sexual_Partners': 'Compañeros sexuales',
    'Weight': 'Peso',
    'Abortions': 'Abortos',
    'Hispanic': 'Hispana',
    'Ethnicity': 'Origen étnico',
    'Height': 'Altura',
    'Cesareans': 'Cesáreas',
    'Last_Menstruation': 'Último periodo menstrual',
    'Drag_boxes_change_results': 'Arrastre las cajas entre las columnas para cambiar los resultados',
    'Delete': 'Borrar',
    'Match_Now': 'Emparejar ahora',
    'Profile': '1. Perfil',
    'History': '2. Historial',
    'New_InstaPap': '3. Nueva prueba InstaPAP',
    'Height_meters': 'Altura en metros',
    'Weight_kg': 'Peso en kilogramos',
    'kg': 'kg',
    'Do_you_smoke': '¿Tabaquismo?',
    'Number_Cesareans': 'Número de cesáreas',
    'Number_Pregnancies': 'Número de embarazos',
    'Number_Sexual_Partners': 'Número de compañeros sexuales',
    'cigarettes_day': 'Número de cigarrillos al día',
    'Number_Abortions': 'Número de abortos',
    'Number_Live_Births': 'Número de nacimientos vivos',
    'Anal_Sex': 'Sexo anal',
    'Save_test_later': 'Guardar y realizar la prueba después',
    'Add_Patient': 'Añadir paciente',
    'Last_Name': 'Apellido',
    'First_Name': 'Nombre',
    'How_hear_about_us': '¿Cómo te enteraste de nosotros?',
    'Cancel': 'Cancelar',
    'Choose': 'Elegir',
    'Other': 'Otro',
    'Irregular_vaginal': 'Sangrado vaginal/cervical irregular',
    'Symptoms_Present:': 'Síntomas presentes:',
    'Observed_Conditions:': 'Condiciones visibles:',
    'Postcoital_bleeding': 'Sangrado post-coito',
    'Vaginal_discharge': 'Secreción vaginal',
    'Smooth': 'Uniforme',
    'Nabothian_Cyst': 'Quiste de Naboth',
    'Hypertrophy': 'Hipertrofía',
    'Leucoplasia': 'Leucoplasia',
    'Inflammation': 'Inflamación',
    'Laceration': 'Laceración',
    'Polyp': 'Pólipo',
    'Suspicious_Lesion': 'Lesión sospechosa',
    'Finish': 'Terminar',
    'Continue_Anyway': 'Continuar',
    'Abandon_Test': 'Prueba finalizada',
    'Pre_Interview_1': 'InstaPAP no debe ser utilizado en mujeres con síntomas anormales, e.g. sangrado vaginal o post-coito, y no debe ser usado en mujeres que tengan un cuello uterino de apariencia anormal. Estas mujeres necesitan una colposcopía, biopsia, histeroscopía, legrado uterino, etc, dependiendo de su historial y hallazgos después de la prueba.',
    'Confirm_Initiate_Test': 'Confirmar e iniciar la prueba InstaPAP',
    'Pre_Interview_2': '¿La paciente está embarazada?',
    'Pre_Interview_3': '¿A la paciente se le ha realizado un Papanicolaou en las últimas 6 semanas?',
    'Pre_Interview_4': '¿La paciente ha dado a luz en los últimos 4 meses?',
    'Pre_Interview_5': '¿La paciente está en los primeros 3 días de su ciclo menstrual con flujo abundante?',
    'Pre_Interview_6': '¿La paciente ha recibido tratamiento quirúrgico en el cuello uterino en los últimos tres meses? (incluyendo biopsias por punción)',
    'Pre_Interview_7': '¿La paciente ha recibido radioterapia en la región pélvica en el pasado?',
    'Pre_Interview_8': '¿La paciente está recibiendo o ha recibido quimioterapia en las últimas 5 semanas?',
    'Pre_Interview_9': '¿A la paciente se le ha realizado una histerectomía?',
    'Pre_Interview_10': '¿La paciente tiene alguna infección aguda o sub-aguda clínicamente aparente en el cuello uterino o vagina?',
    'Pre_Interview_11': '¿La paciente tiene alguna enfermedad fotosensibilizante o está recibiendo terapia fotodinámica o está expuesta a medicamentos fotosensibilizantes?',
    'Exclusion_Criteria': 'Criterios de exclusión',
    'Try_Again': 'Intente nuevamente',
    'Dock_Device_Save': 'Coloque el dispositivo en la base para guardar los resultados y terminar la prueba',
    'Time': 'Hora',
    'Patient': 'Paciente',
    'Points': 'Puntos',
    'Result': 'Resultado',
    'Edit': 'Editar',
    'Abnormal': 'Anormal',
    'still_need_matched': 'Se ha emparejado ${xx} resultado(s). Todavía falta emparejar ${yy} resultado(s).',
    'Saved': 'El resultado de la prueba ha sido emparejado',
    'Edit_Profile_Image': 'Editar imagen de perfil',
    'Device_MAC': 'MAC del dispositivo',
    'Calendly_Key': 'Llave de API de Calend.ly',
    'Tax_ID': 'Identificación de impuestos',
    'Practitioner_ID': 'Identificación del médico',
    'Personal_Info': 'Información personal',
    'Email_Preferences': 'Preferencias de correo electrónico',
    'Add_Device_MAC': 'Añadir dispositivo MAC',
    'Results_Date': 'Fecha de los resultados',
    'Upload_File': 'Adjuntar archivo',
    'Type': 'Tipo',
    'Results': 'Resultados',
    'Status_Update': 'Actualizar resultados',
    'edit_notes': 'Editar notas',
    'status_record_updated_reviewed': 'La(s) prueba(s) _ se actualizaron. Todavía se necesita emparejar la(s) prueba(s) _.',
    'location_of_lesion': 'Por favor haga click en el lugar de la lesión',
    'InstaPap_Test_Interview': 'Entrevista prueba InstaPAP',
    'InstaPap_Test': 'Prueba InstaPAP',
    'Processing_Test': 'Procesando',
    'View_Results': 'Ver resultados',
    'Return_Test': 'Regresar a la prueba',
    'abandon_test_message': '¿Está seguro que desea salir de la prueba? Toda la información se eliminará de manera definitiva. ',
    'Years': 'Años',
    'Please_complete_interview': 'Por favor termine la entrevista para poder ver los resultados.',
    'Please_perform_test': 'Por favor realice la prueba y después coloque el dispositivo en su base.',
    'Accept': 'Aceptar',
    'TruScreen': 'TruScreen',
    'PapSmear_Liquid': 'Papanicolaou de base líquida',
    'HPV_DNA': 'VPH ADN',
    'Manual_InstaPap': 'Manual InstaPAP',
    'Observation': 'Observación',
    'Annual_Checkup': 'Chequeo anual',
    'Enter_note_here': 'Registre nota aquí:',
    'These_are_report_notes': 'Estas son mis notas del reporte',
    'No': 'No',
    'cigarettes': 'cigarrillos',
    'pregnancies': 'embarazos',
    'pregnancy': 'embarazo',
    'live_births': 'nacimientos vivos',
    'live_birth': 'nacimientos vivos',
    'cesareans': 'cesáreas',
    'cesarean': 'cesárea',
    'Abortions': 'abortos',
    'hispanic': 'Hispana',
    'other': 'Otro',
    'None': 'Ninguno',
    'Low': 'Bajo',
    'Med': 'Mediano',
    'High': 'Alto',
    'Physical_examination_notes': 'Registre notas de la examinación física',
    'Current_conditions_notes': 'Registre notas de las condiciones actuales',
    'Forgot_password': '¿Olvidó su contraseña?',
    'Enter_email_reset_password': 'Ingrese su correo electrónico y recibirá una liga para restablecer su contraseña.',
    'Back_to_Login': 'Regresar a página de acceso',
    'Email_not_exist': 'Esa cuenta de correo electrónico no existe',
    'We_sent_an_email': 'Se ha enviado un correo electrónico a ${xx}. De click en la liga para restablecer su contraseña. Si no recibió el correo, revise el buzón de correo no deseado.',
    'Fill_Clinic_Info': 'Por favor ingrese la información de la clínica',
    'Device_MAC_required': 'Se requiere el MAC del dispositivo',
    'New_Patient_Name': '+ Nombre de la nueva paciente',
    'Logout': 'Salir',
    'Enter_new_Password': 'Ingrese una nueva contraseña',
    'New_Password': 'Nueva contraseña',
    'Confirm_New_Password': 'Confirme la nueva contraseña',
    'Your_password_changed': 'Su contraseña se ha cambiado.',
    'Save_Dismiss': 'Guardar y descartar',
    'Email_not_valid': 'Correo electrónico no es válido',
    'Email_password_incorrect': 'El correo electrónico o la contraseña no son válidos',
    'Please_close_window': 'Por favor cierre la ventana y reinicie la prueba',
    'Added_patient_successfully': 'Se añadió la paciente exitosamente',
    'Created_exam_successfully': 'Se ha creado el examen exitosamente',
    'Passwords_not_Match': 'Las contraseñas no coinciden',
    'Password_reset_failed': 'Fallo al restablecer la contraseña',
    'Token_expired': 'El token ha expirado',
    'Update_complete': 'El archivo se ha cargado',
    'Error_signing_up': 'Error durante el registro, por favor trate nuevamente.',
    'MAC_already_use': 'El MAC ya está en uso',
    'Password_confirmation_failed': 'La confirmación de la contraseña ha fallado',
    'Email_password_required': 'Se necesitan el correo electrónico y la contraseña',
    'White': 'Blanca',
    'Indigenous': 'Indígena',
    'Mestizo': 'Mestiza',
    'Asian': 'Asiática',
    'African': 'Africana',
    'Arab': 'Árabe',
    'Other': 'Otra',
    'Add_New_Test_Result': 'Añadir los nuevos resultados de la prueba',
    'No_Status_Available': 'No hay estados disponible',
    'No_Patients_Available': 'No hay pacientes disponibles',
    'No_Tests_Available': 'No hay pruebas disponibles',
    'Upcoming_appointments': 'Citas futuras',
    'No_Upcoming_appointments': 'No hay citas futuras',
    'Add_New_Patient': 'Añadir paciente nueva',
    'Doctor_Database': 'Base de Datos de Doctores',
    'Search_Doctors': 'Buscar Doctores',
    'Location': 'Lugar',
    'Patients': 'Pacientes',
    'No_Doctors_Available': 'No hay doctores disponibles',
    'Add_New_Doctor': 'Añadir doctor nuevo',
    'Super_Admin': 'Super Admin',
    'Exit_Admin': 'Salir Admin',
    'Add_Doctor': 'Añadir doctor',
    'Doctor_Profile': 'Perfil del doctor',
    'Dr': 'Dr',
    'Clinic': 'Clínica',
    'Calendly': 'Calendly',
    'google_calendar': 'Liga de Google Calendar (Dirección secreta en formato iCal)',
    'google_calendar_admin': 'Liga de Google Calendar',
    'google_calendar_how': '¿Cómo encuentro mi liga de Google Calendar?',
    'Account_info': 'Información de la cuenta',
    'Personal_info': 'Información personal',
    'Clinic_info': 'Información de la clínica',
      'update_review_plural': 'Los registros de los estados de la paciente se han actualizado.',
      'update_review': 'El registro del estado de la paciente se ha actualizado.',
      'no_update_review': 'No se actualizó ningún registro de estado de la paciente.',
      'need_review_plural': 'Los registros aún deben ser revisados.',
      'need_review': 'El registro aún debe ser revisado.',
      'no_need_review': 'No se necesita revisar ningún registro.',
      'Phone_Unvalid': 'El número de teléfono no es válido.',
      'messages_on_patient_history_has_no_test': 'Esta paciente no tiene resultados de pruebas actuales. Ingrese uno ahora o inicie una nueva prueba InstaPAP.',
      'how_to_find_gg_calendar_url': '¿Cómo encuentro la liga de mi calendario Google?',
      'gg_calendar_url': 'https://support.google.com/calendar/answer/37648?hl=es-419&vid=0-1244701042136-1527043408766',
      'footer_link': 'http://www.onko.mx',
      'no_test': 'No hay pruebas pasadas',
      'delete_patient_start': 'Está borrando el registro de:',
      'delete_patient_end': 'Esta acción es permanente.',
      'delete_patient_record': 'Confirmar',
      'are_you_sure_delete_test': '¿Está seguro que desea borrar esta prueba?',
      'Edit_Email': 'Editar correo electrónico',
      'To': 'Para',
      'Subject': 'Asunto',
      'Email_body': 'Cuerpo del correo electrónico',
      'Email_content...': 'Contenido del correo electrónico...',
      'Send': 'Enviar',
      'Email_Sent': 'El correo ha sido enviado',
      'Dismiss_Email': 'Continuar',
  },
  'fr': {

  }
}

export default language



//////////////////
// WEBPACK FOOTER
// ./~/languagesp/languagesp.js
// module id = ./node_modules/languagesp/languagesp.js
// module chunks = 1